import { baseApi } from "../../../shared/api/baseApi"
import { IСreateAvailableSchedule } from "../model/create/СreateAvailableSchedule"

export const ScheduleApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getAvailableSchedule: build.query<any, any>({
      query: (params) => ({
        url: `getAvailableSchedule?${params}`,
        method: "GET",
      }),
      providesTags: ["Schedule", "DropoutRate"],
    }),
    addAvailableSchedule: build.mutation<any, any>({
      // поменять any если получится убрать +3
      query: (data) => ({
        url: `addAvailableSchedule`,
        method: "POST",
        body: { ...data },
      }),
      invalidatesTags: ["Schedule"],
    }),
    updateAvailableSchedule: build.mutation<any, IСreateAvailableSchedule>({
      query: (data) => ({
        url: `updateAvailableSchedule`,
        method: "PATCH",
        body: { ...data },
      }),
      invalidatesTags: ["Schedule"],
    }),
    deleteAvailableSchedule: build.mutation<any, IСreateAvailableSchedule>({
      query: (data) => ({
        url: `deleteAvailableSchedule`,
        method: "DELETE",
        body: { ...data },
      }),
      invalidatesTags: ["Schedule"],
    }),
  }),
})

export const {
  useGetAvailableScheduleQuery,
  useAddAvailableScheduleMutation,
  useUpdateAvailableScheduleMutation,
  useDeleteAvailableScheduleMutation,
} = ScheduleApi
